import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ProfessionalSectionForm from './ProfessionalSectionForm'

const ProfessionalSectionEdit: React.FC = () => (
  <SectionWrapper>
    <Edit>
      <ProfessionalSectionForm toolbar={<WithDeleteModalToolbar />} />
    </Edit>
  </SectionWrapper>
)

export default ProfessionalSectionEdit
